import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './../../../services/auth.service';
import { PaymentGatewayMethodEnum } from './../../../models/enums/Payments/PaymnetsEnum';
import { ObjPayment } from './../../../models/Booking/ReservationSaveAndConfirmModel';
import { ProceedPaymentModel } from './../../../models/Payments/ProceedPaymentModel';
import { SearchService } from './../../../services/search.service';
import { BookingService } from './../../../services/booking.service';
import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {  PaymentMethodsEnum, PaymentMode, ProceedPaymentResponseResult, RentalServiceDeliveryChannel } from 'src/app/models/enums/Payments/PaymnetsEnum'
import { ReservationSaveAndConfirmModel } from 'src/app/models/Booking/ReservationSaveAndConfirmModel';
import { AvailablePaymentMethodModel } from 'src/app/models/Payments/AvailablePaymentMethodModel';
import { DepositPolicyModel, LstPolicyReservationCaseModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { DepositPolicyPaymentTypes, PolicyType } from 'src/app/models/enums/BookingEnums';
import { VehicleReservationCaseResult } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { Router } from '@angular/router';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';



declare const payTabsInit: any;
@Component({
  selector: 'payment-edit',
  templateUrl: './payment-edit.component.html',
  styleUrls: ['./payment-edit.component.scss']
})
export class PaymentEditComponent implements OnInit,OnDestroy {
  faTimesCircle = faTimesCircle;
  math = Math;
  paymentForm: FormGroup;
  visaForm: FormGroup;
  chequeForm: FormGroup;
  ACHForm: FormGroup;
  faChevronCircleLeft = faChevronCircleLeft;
  submitted = false;
  selectedMethod;
  PaymentMethods;
  paymentMethodList: AvailablePaymentMethodModel[];
  depositeType: number;

  @Input() vehicleReservationCaseResult: VehicleReservationCaseResult;
  @Input() requiredPayment: number;
  @Input() objPayment: ObjPayment;
  @Output() onCancel = new EventEmitter();
  currency: any;
  accountCreditPostBackMsg: string;

  subscriptions=[];
  @Input() extendpayment: boolean;
  extendpaymentsend: boolean = false;
  customerDetails: { name: any; email: any; country: string; street1: any; city: string; };
  payTabsFormIsDisable: boolean;
  paymentGatewayMethod: PaymentGatewayMethodEnum;

  constructor(private formBuilder: FormBuilder,
    private bookingService: BookingService,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private searchService: SearchService) {

    this.currency = searchService.getCurrency();
  }


  ngOnInit() {

    this.depositeType = DepositPolicyPaymentTypes.FullPaymentIsRequired;
    //Check If Full Payment policy is exist
    if (this.objPayment != null && this.objPayment.depositPolicyPaymentTypes != null) {
      let types = this.objPayment.depositPolicyPaymentTypes;
      let fullPayment = types.filter(a => a == DepositPolicyPaymentTypes.FullPaymentIsRequired);
      if (fullPayment == null) {
        //If no Full Payment policy set any policy as default
        this.depositeType = types[0];
      }

      if (this.extendpayment != null && this.extendpayment)
        this.extendpaymentsend = true;
    }

   this.subscriptions.push( this.authService.loggedInCustomer.subscribe(res => {

      //TODO: MAKE the customer Details address dynamic
      let customerDetails = {
        name: res.defaultName,
        email: res.primaryEmail,
        country: "BR",
        street1: res.fullAdress,
        city: "AMM",
      }
      this.customerDetails = customerDetails;



    }))




    this.paymentForm = this.formBuilder.group({
      FullAmount: ['', Validators.required],
      SecurityDeposit: ['', Validators.required],
    });
    this.visaForm = this.formBuilder.group({
      CardNumber: ['', Validators.required],
      Provider: ['', Validators.required],
      CardHolderName: ['', Validators.required],
      ExpiryMonth: ['', Validators.required],
      ExpiryYear: ['', Validators.required],
      CVC: ['', Validators.required],
    });
    this.chequeForm = this.formBuilder.group({
      ChequeNumber: ['', Validators.required],
      BankName: ['', Validators.required],
      ChequeDate: ['', Validators.required],
    });
    this.ACHForm = this.formBuilder.group({
      BankAccount: ['', Validators.required],
      BankName: ['', Validators.required],
      AccountName: ['', Validators.required],
      Routing: ['', Validators.required],
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })

  }

  get DepositPolicyPaymentTypes() {
    return DepositPolicyPaymentTypes;
  }

  get RentalServiceDeliveryChannel() {
    return RentalServiceDeliveryChannel;
  }

  // convenience getter for easy access to form fields
  get paymentInfo() { return this.paymentForm.controls; }
  get visaInfo() { return this.visaForm.controls; }
  get chequeInfo() { return this.chequeForm.controls; }
  get ACHInfo() { return this.ACHForm.controls; }

  get paymentMethods() {
    return PaymentMethodsEnum;
  }
  get PaymentMode(){
    return PaymentMode;
  }

  get tenantRegisteredPaymentGatewayMethods() {
    if (this.paymentMethodList == null || this.selectedMethod == null) {
      return null;
    }
    let paymentMehtods = this.paymentMethodList.filter(a => a.paymentGatewayLookupID == this.selectedMethod);
    if (paymentMehtods != null) {
      return paymentMehtods[0].lstTenantRegisteredPaymentGatewayMethods;
    }
    return null;
  }

  get paymentGatewayMethodEnum() {
    return PaymentGatewayMethodEnum;
  }



  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.paymentForm.invalid) {
      return;
    }

    // display form values on success
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.paymentForm.value, null, 4));
  }

  onReset() {
    this.submitted = false;
    this.paymentForm.reset();
  }








  cancelClicked() {
    this.onCancel.emit(true);
  }


}
